import * as React from 'react';

import { AppFormField, AppFormFieldProps, AppFormFieldOwnProps } from './appFormField';

export interface AppTextAreaFieldProps extends AppFormFieldOwnProps {
  rows?: number;
}

export class AppTextAreaField extends AppFormField<AppTextAreaFieldProps> {
  protected renderInput(field: AppFormFieldProps): JSX.Element {
    const { rows = 5, placeholder, disabled } = this.props;

    return (
      <textarea
        {...field.input}
        className={`${this.isFieldInvalid(field) ? 'invalid' : ''} text-input form-control`}
        placeholder={placeholder}
        rows={rows}
        disabled={disabled}
      />
    );
  }
}
